/* tslint:disable */
/* eslint-disable */
/**
 * Order App API
 * Provides management of all Order operations. Version 0.X is not supported in PRO and doesn\'t have all endpoints implemented.
 *
 * The version of the OpenAPI document: v1
 * Contact: Commerce-Purchase@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DetailProjection = {
    Detailed: 'DETAILED',
    Summary: 'SUMMARY',
    AdminDetailed: 'ADMIN_DETAILED',
    AdminSummary: 'ADMIN_SUMMARY'
} as const;
export type DetailProjection = typeof DetailProjection[keyof typeof DetailProjection];


export function DetailProjectionFromJSON(json: any): DetailProjection {
    return DetailProjectionFromJSONTyped(json, false);
}

export function DetailProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailProjection {
    return json as DetailProjection;
}

export function DetailProjectionToJSON(value?: DetailProjection | null): any {
    return value as any;
}

